<template>
  <div class="p-realtime container">
    <div ref="hot" class="p-realtime__body">
      <div v-if="datas !== null" ref="hotContent" class="p-realtime__content">
        <div class="p-realtime__list">
          <div v-for="i in datas.articles.items" :key="i.article_id" class="p-realtime__item">
            <a :href="`/article/${i.article_id}/`" class="m-card-s" target="_blank" rel="noreferrer noopener" title="另開視窗連結至新聞頁面">
              <div class="m-card-s__img-container">
                <div v-if="i.type !== 'general'" class="e-type--bg m-card-s__type">
                  <span :class="articleType(i).style" class="e-type">
                    {{ articleType(i).text }}
                  </span>
                </div>
                <LazyImage width="136" height="72" :src="i.cover.xs" :alt="i.caption" class="m-card-s__img p-realtime__item-img" />
              </div>
              <div class="m-card-s__content p-realtime__item-content">
                <h2 class="m-card-s__title m-card--mle-2">
                  {{ i.title }}
                </h2>
                <div class="m-card-s__footer">
                  <time :datetime="i.publish_at" class="e-time">
                    <img src="https://static.ctwant.com/images/dist/clock.svg" class="m-card__clock" width="14" height="14" alt="發佈時間圖示">
                    {{ i.publish_at }}
                  </time>
                  <span class="m-card-s__btn p-realtime__read">
                    繼續閱讀
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <Pagination
          v-if="datas !== null"
          :current-page="datas.articles.current_page"
          :total-page="datas.articles.last_page"
          @update="pageChange($event); isClickChange = true"
        />
      </div>
      <!-- 側邊欄 -->
      <SideBar :data="datas" />
      <SideBarForMobile :data="datas" />
      <!-- 側邊欄 -->
    </div>
  </div>
</template>

<router lang="js">
  {
    path: encodeURI('/category/最新')
  }
</router>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import Pagination from '@/components/Pagination.vue'
import LazyImage from '@/components/LazyImage.vue'
import scrollToTop from '@/utils/scrollToTop'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'

export default {
  components: {
    Pagination,
    LazyImage,
    SideBar,
    SideBarForMobile
  },
  mixins: [articleHelpers],
  async asyncData({ $axios, route, error }) {
    const api = $axios.defaults.baseURL
    let url = `${api}${route.path}`

    if (route.query.page) {
      url = `${api}${route.path}?page=${route.query.page}`
    }

    try {
      const { data } = await $axios.$get(url)
      return { datas: data }
    } catch (e) {
      console.error('Realtime', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      pageTitle: '最新 | CTWANT',
      datas: null,
      listAdCount: 0,
      isClickChange: false
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    return {
      title: this.pageTitle,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: this.pageTitle }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST'
    ])
  },
  watch: {
    $route(to, from) {
      if (!this.isClickChange) {
        this.pageChange(to.query.page)
      }
    }
  },
  mounted() {
    const vm = this

    this.$nextTick(() => {
      vm.$gtm.push({
        event: 'domMounted',
        pageUrl: vm.$route.fullPath,
        pageTitle: vm.$metaInfo.title,
        pageCategory: '最新'
      })
      this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd')
    })
  },
  methods: {
    async pageChange(page) {
      const api = this.$axios.defaults.baseURL
      const url = `${api}/category/最新?page=${page}`
      try {
        const { data } = await this.$axios.$get(encodeURI(url))
        this.datas = data
        this.$nextTick(() => {
          scrollToTop()
        })
      } catch (e) {
        console.error('Realtime pageChange', {
          code: e.response.data.code,
          message: e.response.data.message,
          method: e.response.config.method,
          url: e.response.config.url
        })
        this.error({ statusCode: 404 })
      }
      this.isClickChange = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_realtime';
</style>
